import { SET_REDUX_CONFIRM_MODAL_DATA, SET_REDUX_CONFIRM_MODAL_SHOW } from "../types";

const initialState = {
    show: false,
    title: 'Please Confirm',
    body: '',
    onConfirm: () => {},
    hasConfirm: false,
    confirmText: 'Confirm',
    closeText: 'Close'
};

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SET_REDUX_CONFIRM_MODAL_SHOW:
            return {
                ...state,
                show: payload.show,
                title: payload.title
            };
        case SET_REDUX_CONFIRM_MODAL_DATA:
            return {
                ...state,
                ...payload
            };
        default:
            return state;
    }
}
